import { PrefillSelect } from "../../../../components/input";
import React from "react";
import { useLoanReasons } from "../../../../hooks/resources";

function getPlaceholder(isLoading, hasFailed) {
  if (isLoading) {
    return "Loading...";
  }

  if (hasFailed) {
    return "Error";
  }

  return undefined;
}

export const LoanReason = () => {
  const [loanReasons, isLoading, hasFailed] = useLoanReasons();
  const { personalLoan } = loanReasons;

  return (
    <PrefillSelect
      title="Please help us understand the purpose of your loan"
      name="accountPurpose"
      placeholder={getPlaceholder(isLoading, hasFailed)}
      options={personalLoan}
      isLoading={isLoading}
    />
  );
};